/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterServices {
    getFixupPrototypeFunction() { return FilterServices.fixupPrototype; }

    static newInstance(model: Partial<FilterServices>): FilterServices {
        let obj = Object.assign(new FilterServices(), model);
        FilterServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterServices>): FilterServices {
        if (!model) return null;
        return FilterServices.newInstance(<FilterServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterServices) {
        if (!obj) return;

        models.FilterServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterServices): boolean {
        Object.setPrototypeOf(obj, FilterServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * cloud account type
     */
    cloud_account_type: Array<any>;

    /**
     * currency types
     */
    currency: Array<any>;

}
